var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 48.75V27.5C10 25.5 10.75 23.75 12.25 22.25C13.75 20.75 15.5 20 17.5 20H102.5C104.5 20 106.25 20.75 107.75 22.25C109.25 23.75 110 25.5 110 27.5V48.75H102.5V27.5H17.5V48.75H10ZM17.5 100C15.5 100 13.75 99.25 12.25 97.75C10.75 96.25 10 94.5 10 92.5V71.25H17.5V92.5H102.5V71.25H110V92.5C110 94.5 109.25 96.25 107.75 97.75C106.25 99.25 104.5 100 102.5 100H17.5ZM49.9761 83.75C50.6587 83.75 51.3167 83.5833 51.95 83.25C52.5833 82.9167 53.0583 82.4167 53.375 81.75L70 48.5L76.625 61.75C76.9375 62.4167 77.4062 62.9167 78.0312 63.25C78.6562 63.5833 79.3125 63.75 80 63.75H110V56.25H82.375L73.375 38.375C73.0647 37.6875 72.5993 37.2031 71.9788 36.9219C71.3582 36.6406 70.7065 36.5 70.0239 36.5C69.3413 36.5 68.6833 36.6406 68.05 36.9219C67.4167 37.2031 66.9417 37.6875 66.625 38.375L50 71.5L43.375 58.25C43.0625 57.5833 42.5938 57.0833 41.9688 56.75C41.3438 56.4167 40.6875 56.25 40 56.25H10V63.75H37.625L46.625 81.75C46.9353 82.4167 47.4007 82.9167 48.0213 83.25C48.6418 83.5833 49.2935 83.75 49.9761 83.75Z",
    fill: "url(#paint0_linear_3_85)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_85",
    x1: 60,
    y1: 20,
    x2: 60,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D81C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2594BD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExame);
export default __webpack_public_path__ + "static/media/exame.8283cd42f71afe9007ed2f2096fb64c5.svg";
export { ForwardRef as ReactComponent };